import eventBus from "@/utils/eventBus";

/** 保存前把当前页 componentData 写入 canvasAllData（避免仍用懒加载骨架做校验） */
export function requestFlushCurrentPageBeforeSave() {
  return new Promise((resolve) => {
    eventBus.$emit("flushCurrentPageBeforeSave", {
      done() {
        resolve();
      },
    });
  });
}

/** 保存校验前拉取工程内全部页面完整数据（懒加载工程会从服务端 findPage） */
export function requestEnsureAllProjectPagesBeforeSave() {
  return new Promise((resolve) => {
    eventBus.$emit("ensureAllProjectPagesBeforeSave", {
      done() {
        resolve();
      },
    });
  });
}
